import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { useScrollReveal } from '../../utils/hooks/useScrollReveal';

const SNSShareSection = () => {
  const { t } = useTranslation();
  const sectionRef = useScrollReveal();

  const hashtag = '#외상센터살리기';
  const shareText = t('involvement.sns.shareText');
  const shareUrl = 'https://tchelp.org'; // 실제 웹사이트 URL

  const handleFacebookShare = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText + ' ' + hashtag)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const handleTwitterShare = () => {
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&hashtags=${encodeURIComponent(hashtag.replace('#', ''))}&url=${encodeURIComponent(shareUrl)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const handleInstagramShare = () => {
    // Instagram은 웹에서 직접 공유 불가, 앱으로 이동
    alert(t('involvement.sns.instagramNote'));
  };

  const handleCopyLink = () => {
    const textToCopy = `${shareText} ${hashtag}\n${shareUrl}`;
    navigator.clipboard.writeText(textToCopy).then(() => {
      alert(t('involvement.sns.linkCopied'));
    });
  };

  return (
    <section ref={sectionRef} className="sns-share-section scroll-reveal">
      <div className="involvement-card">
        <div className="involvement-icon">
          <FontAwesomeIcon icon={faShareAlt} />
        </div>
        <h3>{t('involvement.sns.title')}</h3>
        <p>{t('involvement.sns.description')}</p>

        <div className="hashtag-display">
          <span className="hashtag">{hashtag}</span>
        </div>

        <div className="sns-buttons">
          <button onClick={handleFacebookShare} className="sns-btn facebook">
            <FontAwesomeIcon icon={faFacebook} /> Facebook
          </button>
          <button onClick={handleTwitterShare} className="sns-btn twitter">
            <FontAwesomeIcon icon={faTwitter} /> Twitter
          </button>
          <button onClick={handleInstagramShare} className="sns-btn instagram">
            <FontAwesomeIcon icon={faInstagram} /> Instagram
          </button>
          <button onClick={handleCopyLink} className="sns-btn copy">
            {t('involvement.sns.copyLink')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default SNSShareSection;
